<template>
  <v-app app>
    <dashboard-core-drawer />
    <dashboard-core-view />
    <LoadingSpinner />
  </v-app>
</template>

<script>
import LoadingSpinner from "@/views/dashboard/components/LoadingSpinner";

export default {
  name: "DashboardIndex",

  components: {
    DashboardCoreDrawer: () => import("./components/core/Drawer"),
    DashboardCoreView: () => import("./components/core/View"),
    LoadingSpinner
  }
};
</script>
